import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

//Layout
import Admin from '../layouts/Admin';
import AdminMunicipe from '../layouts/AdminMunicipe';
import Auth from '../layouts/Auth';

//Context
import { useAuth } from '../context/auth';

//Components
import Loading from '../components/Loading/Loading';

export default function RoutesComponent() {
    const { session, loading } = useAuth();
    return (
        <BrowserRouter>
            {loading && <Loading />}
            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path="/" element={<Navigate to={`auth/login`} />} />
                    <Route path={`auth/*`} element={<Auth />} />
                    {
                        session != null && (session.perfil == "Municipe" || session.perfil == "Master") &&
                        <Route path={`municipe/*`} element={<AdminMunicipe />} />
                    }
                    {
                        session != null && (session.perfil == "Gestor" || session.perfil == "Master") &&
                        <Route path={`admin/*`} element={<Admin />} />
                    }
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}